module.exports = "../../static/loader.af2eb4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader.svg
// module id = rmBI
// module chunks = 3